const SET_SERVICES_AND_EVENTS = 'SET_SERVICES_AND_EVENTS';

export { SET_SERVICES_AND_EVENTS };
